var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.5C16 5.9 14.9 7 13.5 7S11 5.9 11 4.5 12.1 2 13.5 2 16 3.1 16 4.5zM13 15c0 1-.5 2-2 2H2c-1.5 0-2-1-2-2 0-3 3-5 6.5-5s6.5 2 6.5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15c1.4 0 2-1 2-2 0-3-3-5-6.7-5-1 0-2.2.3-2.7.7-.6.4-.5.9 0 1.1C13.1 11 14 12.9 14 14c0 .6.4 1 1 1h3zM9 6.5C9 7.9 7.9 9 6.5 9S4 7.9 4 6.5 5.1 4 6.5 4 9 5.1 9 6.5z"
  })));
};
export default SvgUsers;